import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>
        {' '} Connect with me on {' '}
        <a
          href="https://www.linkedin.com/in/thenameisshuvo/"
          target="_blank"
          rel="noopener noreferrer"
          title="LinkedIn Profile"
        >
          LinkedIn
        </a>
        
      </p>
    </footer>
  );
}

export default Footer;
